import React from 'react';

export default function CFPSection({ cfpData }) {
    if (!cfpData) return null;
    
    const tracks = cfpData.tracks || [];
    const timeline = cfpData.timeline || [];

    return (
        <section id="cfp" className="bsides-cfp">
            <style>{`
                .bsides-cfp {
                    background: var(--eventflow-black);
                    padding: 100px 0;
                    position: relative;
                    overflow: hidden;
                }
                .bsides-cfp::before {
                    content: '';
                    position: absolute;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background:
                        radial-gradient(ellipse at 80% 20%, rgba(var(--eventflow-primary-rgb),0.12) 0%, transparent 55%),
                        radial-gradient(ellipse at 20% 80%, rgba(var(--eventflow-base-rgb),0.08) 0%, transparent 50%);
                    pointer-events: none;
                }

                /* section title */
                .bsides-section-tag {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px;
                    font-weight: 600;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    color: var(--eventflow-base);
                    margin-bottom: 16px;
                }
                .bsides-section-tag::before,
                .bsides-section-tag::after {
                    content: '';
                    display: inline-block;
                    width: 28px; height: 1px;
                    background: var(--eventflow-base);
                    opacity: 0.5;
                }
                .bsides-section-title {
                    font-family: var(--eventflow-font);
                    font-size: 48px;
                    font-weight: 800;
                    color: var(--eventflow-white);
                    line-height: 1.1;
                    letter-spacing: -1px;
                    margin-bottom: 16px;
                }
                .bsides-section-title span { color: var(--eventflow-base); }
                .bsides-section-desc {
                    font-family: var(--eventflow-font);
                    font-size: 16px;
                    line-height: 1.75;
                    color: rgba(var(--eventflow-white-rgb), 0.6);
                    max-width: 560px;
                }

                /* tracks grid */
                .cfp-tracks {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 16px;
                    margin-top: 48px;
                }
                .cfp-track {
                    background: rgba(var(--eventflow-white-rgb), 0.03);
                    border: 1px solid rgba(var(--eventflow-white-rgb), 0.08);
                    border-radius: 12px;
                    padding: 24px 20px;
                    transition: border-color 0.3s, background 0.3s, transform 0.3s;
                    cursor: default;
                }
                .cfp-track:hover {
                    border-color: rgba(var(--eventflow-base-rgb), 0.4);
                    background: rgba(var(--eventflow-base-rgb), 0.05);
                    transform: translateY(-3px);
                }
                .cfp-track__icon {
                    width: 44px; height: 44px;
                    border-radius: 10px;
                    background: rgba(var(--eventflow-base-rgb), 0.12);
                    display: flex; align-items: center; justify-content: center;
                    margin-bottom: 14px;
                }
                .cfp-track__icon i {
                    font-size: 18px;
                    color: var(--eventflow-base);
                }
                .cfp-track__title {
                    font-family: var(--eventflow-font);
                    font-size: 15px;
                    font-weight: 700;
                    color: var(--eventflow-white);
                    margin-bottom: 8px;
                }
                .cfp-track__desc {
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    line-height: 1.6;
                    color: rgba(var(--eventflow-white-rgb), 0.5);
                    margin: 0;
                }

                /* timeline */
                .cfp-timeline {
                    display: flex;
                    flex-direction: column;
                    gap: 0;
                    margin-top: 40px;
                }
                .cfp-timeline__item {
                    display: flex;
                    align-items: flex-start;
                    gap: 16px;
                    padding-bottom: 28px;
                    position: relative;
                }
                .cfp-timeline__item:not(:last-child)::after {
                    content: '';
                    position: absolute;
                    left: 15px; top: 32px;
                    width: 1px;
                    bottom: 0;
                    background: rgba(var(--eventflow-white-rgb), 0.1);
                }
                .cfp-timeline__dot {
                    width: 32px; height: 32px;
                    border-radius: 50%;
                    border: 2px solid rgba(var(--eventflow-base-rgb), 0.4);
                    background: rgba(var(--eventflow-base-rgb), 0.1);
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0;
                    position: relative; z-index: 1;
                }
                .cfp-timeline__dot i {
                    font-size: 11px;
                    color: var(--eventflow-base);
                }
                .cfp-timeline__label {
                    font-family: var(--eventflow-font);
                    font-size: 15px;
                    font-weight: 700;
                    color: var(--eventflow-white);
                    margin-bottom: 2px;
                }
                .cfp-timeline__date {
                    font-family: var(--eventflow-font);
                    font-size: 13px;
                    color: rgba(var(--eventflow-white-rgb), 0.45);
                }

                /* form */
                .cfp-form-wrap {
                    background: rgba(var(--eventflow-white-rgb), 0.03);
                    border: 1px solid rgba(var(--eventflow-white-rgb), 0.08);
                    border-radius: 16px;
                    padding: 40px;
                    margin-top: 60px;
                }
                .cfp-form-wrap h3 {
                    font-family: var(--eventflow-font);
                    font-size: 26px;
                    font-weight: 800;
                    color: var(--eventflow-white);
                    margin-bottom: 8px;
                }
                .cfp-form-wrap p {
                    font-size: 14px;
                    color: rgba(var(--eventflow-white-rgb), 0.5);
                    margin-bottom: 28px;
                }
                .cfp-form {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 16px;
                }
                .cfp-form__full { grid-column: 1 / -1; }
                .cfp-form input,
                .cfp-form select,
                .cfp-form textarea {
                    width: 100%;
                    background: rgba(var(--eventflow-white-rgb), 0.05);
                    border: 1px solid rgba(var(--eventflow-white-rgb), 0.1);
                    border-radius: 8px;
                    padding: 12px 16px;
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    color: var(--eventflow-white);
                    outline: none;
                    transition: border-color 0.3s;
                }
                .cfp-form input::placeholder,
                .cfp-form textarea::placeholder { color: rgba(var(--eventflow-white-rgb), 0.3); }
                .cfp-form input:focus,
                .cfp-form select:focus,
                .cfp-form textarea:focus { border-color: rgba(var(--eventflow-base-rgb), 0.5); }
                .cfp-form select option { background: #1a0a1a; color: #fff; }
                .cfp-form textarea { resize: vertical; min-height: 120px; }
                .cfp-success {
                    text-align: center;
                    padding: 40px 20px;
                }
                .cfp-success i {
                    font-size: 48px;
                    color: var(--eventflow-base);
                    margin-bottom: 16px;
                    display: block;
                }
                .cfp-success h4 {
                    font-family: var(--eventflow-font);
                    font-size: 22px;
                    font-weight: 700;
                    color: var(--eventflow-white);
                    margin-bottom: 8px;
                }
                .cfp-success p {
                    color: rgba(var(--eventflow-white-rgb), 0.5);
                    font-size: 14px;
                    margin: 0;
                }

                @media (max-width: 991px) {
                    .cfp-tracks { grid-template-columns: repeat(2, 1fr); }
                    .bsides-section-title { font-size: 36px; }
                }
                @media (max-width: 576px) {
                    .cfp-tracks { grid-template-columns: 1fr; }
                    .cfp-form { grid-template-columns: 1fr; }
                    .cfp-form-wrap { padding: 24px 20px; }
                }
            `}</style>

            <div className="container">
                {/* Header */}
                <div className="row align-items-center mb-5">
                    <div className="col-lg-7 wow fadeInLeft" data-wow-delay="100ms">
                        <div className="bsides-section-tag">Call For Papers</div>
                        <h2 className="bsides-section-title">Submit Your <span>Talk or Workshop</span></h2>
                        <p className="bsides-section-desc">
                            BSides Coimbatore is a community-driven conference. We welcome talks, workshops, and research from security professionals, researchers, and enthusiasts at all levels.
                        </p>
                    </div>
                    <div className="col-lg-5 wow fadeInRight" data-wow-delay="200ms">
                        <div className="cfp-timeline">
                            {timeline.map((t, i) => (
                                <div className="cfp-timeline__item" key={i}>
                                    <div className="cfp-timeline__dot">
                                        <i className="fa fa-calendar-check" />
                                    </div>
                                    <div>
                                        <div className="cfp-timeline__label">{t.label}</div>
                                        <div className="cfp-timeline__date">{t.date}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Tracks */}
                <div className="cfp-tracks wow fadeInUp" data-wow-delay="100ms">
                    {tracks.map((t, i) => (
                        <div className="cfp-track" key={i}>
                            <div className="cfp-track__icon"><i className={`fa ${t.icon}`} /></div>
                            <div className="cfp-track__title">{t.title}</div>
                            <p className="cfp-track__desc">{t.desc}</p>
                        </div>
                    ))}
                </div>

                {/* Submit CTA */}
                <div className="cfp-form-wrap wow fadeInUp" data-wow-delay="200ms" style={{textAlign:'center'}}>
                    <h3>Ready to Submit?</h3>
                    <p>Click the button below to submit your talk or workshop proposal for BSides Coimbatore 2027.</p>
                    <a
                        href={cfpData.cta.buttonLink || '#'}
                        className="thm-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{display:'inline-flex', marginTop:'8px'}}
                    >
                        {cfpData.cta.buttonText} <span className="icon-arrow-right" />
                    </a>
                    <p style={{marginTop:'16px',fontSize:'12px',color:'rgba(255,255,255,0.3)',marginBottom:0}}>
                        Questions? Email <a href="mailto:info@bsidescoimbatore.in" style={{color:'var(--eventflow-base)'}}>info@bsidescoimbatore.in</a>
                    </p>
                </div>
            </div>
        </section>
    );
}


